/* eslint-disable max-len, no-trailing-spaces, eol-last, indent, comma-dangle, comma-spacing, prefer-const, spaced-comment, key-spacing, no-multi-spaces, semi, object-property-newline, quotes, react/display-name, id-length, operator-linebreak, react/prop-types, no-shadow, no-undef, max-lines-per-function, space-infix-ops, no-unused-vars, init-declarations */
import { serviceName } from '../resources/serviceConstants';
import {
  SKILL_MAP_REPORT_PDF,
  SKILL_MAP_REPORT_EXCEL,
} from '../resources/endPoint';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';
import AxiosWrapper from '../http/AxiosWrapper';

const Wrapper = new AxiosWrapper();

const getDataFile = async (
  service,
  baseUrl,
  path,
  downloadName,
  contentType,
  filters,
) => {
  try {
    const servicePort = appendServicePortToURL(service);
    const serviceURL = appendServiceNameToURL(service);

    const url =
      process.env.NODE_ENV === 'development'
        ? `${baseUrl}:${servicePort}${serviceURL}/api${path}`
        : `${baseUrl}${serviceURL}/api${path}`;
    const authToken = Wrapper.getAuthToken();
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        token: authToken,
      },
      body: JSON.stringify(filters),
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = globalThis.URL.createObjectURL(blob);
    link.download = downloadName;
    link.click();
  } catch (error) {
    console.error(`Failed to download ${contentType}:`, error);
    throw new Error(`Failed to download ${contentType}: ` + error.message);
  }
};

export const getSkillMappingDataPdf = async (filters) => {
  const service = serviceName.SKILLS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = SKILL_MAP_REPORT_PDF;
  const downloadName = 'skill_mapping.pdf';
  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/pdf',
    filters,
  );
};

export const getSkillMappingExcel = async (filters) => {
  const service = serviceName.SKILLS_MS;
  const baseUrl = process.env.REACT_APP_API_URL;
  const path = SKILL_MAP_REPORT_EXCEL;
  const downloadName = 'skill_mapping.xlsx';

  await getDataFile(
    service,
    baseUrl,
    path,
    downloadName,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    filters,
  );
};
